var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtDoneChanges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.799 8.20094C42.5105 2.91255 35.4791 0 28 0C20.5208 0 13.4893 2.91255 8.20094 8.20094C2.91244 13.4894 0 20.5209 0 28C0 35.4791 2.91244 42.5105 8.20094 47.799C13.4894 53.0875 20.5208 56 28 56C35.4791 56 42.5105 53.0875 47.799 47.799C53.0875 42.5105 56 35.4791 56 28C56 20.5209 53.0875 13.4895 47.799 8.20094ZM28 52.7188C14.37 52.7188 3.28125 41.63 3.28125 28C3.28125 14.37 14.37 3.28125 28 3.28125C41.63 3.28125 52.7188 14.37 52.7188 28C52.7188 41.63 41.63 52.7188 28 52.7188Z",
    fill: "#5CB5A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3765 19.0158C40.7359 18.3753 39.697 18.3753 39.0564 19.0159L24.5687 33.5036L16.9423 25.8772C16.3017 25.2366 15.2629 25.2366 14.6221 25.8772C13.9814 26.5178 13.9814 27.5566 14.6221 28.1974L23.4086 36.9838C23.5607 37.1363 23.7416 37.2573 23.9406 37.3398C24.1397 37.4222 24.3531 37.4645 24.5686 37.4643C24.9884 37.4643 25.4084 37.304 25.7286 36.9838L41.3765 21.3359C42.0172 20.6953 42.0172 19.6565 41.3765 19.0158Z",
    fill: "#5CB5A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtDoneChanges);
export default __webpack_public_path__ + "static/media/art-done-changes.c2ca49e9e4f2bdfb3a414b547c0ba867.svg";
export { ForwardRef as ReactComponent };